import { render, staticRenderFns } from "./CustomCollapse.vue?vue&type=template&id=44ca2875"
import script from "./CustomCollapse.vue?vue&type=script&lang=js"
export * from "./CustomCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports